import { render, staticRenderFns } from "./shouyeCategory.vue?vue&type=template&id=ef27e4a4&scoped=true&"
import script from "./shouyeCategory.vue?vue&type=script&lang=js&"
export * from "./shouyeCategory.vue?vue&type=script&lang=js&"
import style0 from "./shouyeCategory.vue?vue&type=style&index=0&id=ef27e4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef27e4a4",
  null
  
)

export default component.exports